import { Component } from '@angular/core';

import { GLinkConfigService } from 'app/core/services/config.service';
import { glinkAnimations } from 'app/core/animations';

@Component({
    selector   : 'mail-confirm',
    templateUrl: './mail-confirm.component.html',
    styleUrls  : ['./mail-confirm.component.scss'],
    animations : glinkAnimations
})
export class MailConfirmComponent
{
    /**
     * Constructor
     *
     * @param {GLinkConfigService} _glinkConfigService
     */
    constructor(
        private _glinkConfigService: GLinkConfigService
    )
    {
        // Configure the layout
        this._glinkConfigService.config = {
            layout: {
                navbar : {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer : {
                    hidden: true
                }
            }
        };
    }
}
